var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIconGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EA9D4CB5-72B4-437C-A8F7-41FBC3F4F4E7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-app",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web-pub-info",
    transform: "translate(-627, -326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(98, 312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit-icon-green",
    transform: "translate(529, 14)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,19 L6.4,19 L15.025,10.375 L13.625,8.975 L5,17.6 L5,19 Z M19.3,8.925 L15.05,4.725 L16.45,3.325 C16.8333,2.94167 17.3042,2.75 17.8625,2.75 C18.4208,2.75 18.8917,2.94167 19.275,3.325 L20.675,4.725 C21.0583,5.10833 21.2583,5.57083 21.275,6.1125 C21.2917,6.65417 21.1083,7.11667 20.725,7.5 L19.3,8.925 Z M4,21 C3.71667,21 3.47917,20.9042 3.2875,20.7125 C3.09583,20.5208 3,20.2833 3,20 L3,17.175 C3,17.0417 3.025,16.9125 3.075,16.7875 C3.125,16.6625 3.2,16.55 3.3,16.45 L13.6,6.15 L17.85,10.4 L7.55,20.7 C7.45,20.8 7.3375,20.875 7.2125,20.925 C7.0875,20.975 6.95833,21 6.825,21 L4,21 Z",
    id: "Shape",
    fill: "#CEFAB7",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconGreen);
export default __webpack_public_path__ + "static/media/edit-icon-green.227d6b19bcd58c89718c8fec0d5d2d32.svg";
export { ForwardRef as ReactComponent };